import { LoanType } from '@/types';

export interface PayoutSlab {
  range: string;
  payout: string;
}

export interface PayoutData {
  lender: string;
  loanType: LoanType;
  maxPayout: string;
  dsaCode: string;
  slabs: PayoutSlab[];
  remarks?: string;
}

export const payoutsData: PayoutData[] = [
  {
    lender: 'HDFC Bank',
    loanType: 'home_loan',
    maxPayout: '1%',
    dsaCode: 'HDFC-DSA-2024',
    slabs: [
      { range: '< 1 Crore', payout: '0.5%' },
      { range: '1-2 Crore', payout: '0.6%' },
      { range: '2-5 Crore', payout: '0.8%' },
      { range: '> 5 Crore', payout: '1%' },
    ],
    remarks: 'On BT case within 6 months payout will be reversed',
  },
  {
    lender: 'HDFC Bank',
    loanType: 'lap',
    maxPayout: '1.5%',
    dsaCode: 'HDFC-LAP-2024',
    slabs: [
      { range: '< 50 Lakhs', payout: '0.75%' },
      { range: '50L-1 Crore', payout: '1%' },
      { range: '1-3 Crore', payout: '1.25%' },
      { range: '> 3 Crore', payout: '1.5%' },
    ],
  },
  {
    lender: 'SBI',
    loanType: 'home_loan',
    maxPayout: '0.8%',
    dsaCode: 'SBI-HL-DSA-001',
    slabs: [
      { range: '< 50 Lakhs', payout: '0.4%' },
      { range: '50L-1 Crore', payout: '0.5%' },
      { range: '1-2 Crore', payout: '0.65%' },
      { range: '> 2 Crore', payout: '0.8%' },
    ],
    remarks: 'Additional 0.1% for government employees',
  },
  {
    lender: 'SBI',
    loanType: 'business_loan',
    maxPayout: '1.2%',
    dsaCode: 'SBI-BL-2024',
    slabs: [
      { range: '< 25 Lakhs', payout: '0.6%' },
      { range: '25L-50 Lakhs', payout: '0.8%' },
      { range: '50L-1 Crore', payout: '1%' },
      { range: '> 1 Crore', payout: '1.2%' },
    ],
  },
  {
    lender: 'ICICI Bank',
    loanType: 'home_loan',
    maxPayout: '1.1%',
    dsaCode: 'ICICI-DSA-2024',
    slabs: [
      { range: '< 75 Lakhs', payout: '0.5%' },
      { range: '75L-1.5 Crore', payout: '0.7%' },
      { range: '1.5-3 Crore', payout: '0.9%' },
      { range: '> 3 Crore', payout: '1.1%' },
    ],
    remarks: 'Payout processed within 15 days of disbursement',
  },
  {
    lender: 'ICICI Bank',
    loanType: 'personal_loan',
    maxPayout: '2.5%',
    dsaCode: 'ICICI-PL-DSA',
    slabs: [
      { range: '< 5 Lakhs', payout: '1.5%' },
      { range: '5-10 Lakhs', payout: '2%' },
      { range: '> 10 Lakhs', payout: '2.5%' },
    ],
  },
  {
    lender: 'Axis Bank',
    loanType: 'home_loan',
    maxPayout: '1%',
    dsaCode: 'AXIS-HL-2024',
    slabs: [
      { range: '< 1 Crore', payout: '0.5%' },
      { range: '1-2 Crore', payout: '0.7%' },
      { range: '2-4 Crore', payout: '0.85%' },
      { range: '> 4 Crore', payout: '1%' },
    ],
  },
  {
    lender: 'Axis Bank',
    loanType: 'car_loan',
    maxPayout: '1.5%',
    dsaCode: 'AXIS-CAR-DSA',
    slabs: [
      { range: '< 10 Lakhs', payout: '1%' },
      { range: '10-25 Lakhs', payout: '1.25%' },
      { range: '> 25 Lakhs', payout: '1.5%' },
    ],
    remarks: 'New car only. Used car payout 0.5% less',
  },
  {
    lender: 'Bajaj Finance',
    loanType: 'home_loan',
    maxPayout: '1.25%',
    dsaCode: 'BAJAJ-HL-2024',
    slabs: [
      { range: '< 50 Lakhs', payout: '0.6%' },
      { range: '50L-1 Crore', payout: '0.8%' },
      { range: '1-2 Crore', payout: '1%' },
      { range: '> 2 Crore', payout: '1.25%' },
    ],
  },
  {
    lender: 'Bajaj Finance',
    loanType: 'personal_loan',
    maxPayout: '3%',
    dsaCode: 'BAJAJ-PL-DSA',
    slabs: [
      { range: '< 3 Lakhs', payout: '2%' },
      { range: '3-7 Lakhs', payout: '2.5%' },
      { range: '> 7 Lakhs', payout: '3%' },
    ],
    remarks: 'Instant approval cases get additional 0.25%',
  },
];

export const lenders = [...new Set(payoutsData.map(p => p.lender))];
export const loanTypes: LoanType[] = ['home_loan', 'lap', 'personal_loan', 'business_loan', 'car_loan'];
